var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "var(--icon-fill)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2734_69",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 25,
    height: 25,
    fill: "var(--icon-fill)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2734_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 24C9.125 24 6.46875 22.9062 4.28125 20.7188C2.09375 18.5312 1 15.875 1 12.75C1 9.625 2.09375 6.96875 4.28125 4.78125C6.46875 2.59375 9.125 1.5 12.25 1.5C12.5417 1.5 12.8281 1.51042 13.1094 1.53125C13.3906 1.55208 13.6667 1.58333 13.9375 1.625C13.0833 2.22917 12.401 3.01563 11.8906 3.98438C11.3802 4.95313 11.125 6 11.125 7.125C11.125 9 11.7813 10.5937 13.0938 11.9062C14.4063 13.2187 16 13.875 17.875 13.875C19.0208 13.875 20.0729 13.6198 21.0312 13.1094C21.9896 12.599 22.7708 11.9167 23.375 11.0625C23.4167 11.3333 23.4479 11.6094 23.4688 11.8906C23.4896 12.1719 23.5 12.4583 23.5 12.75C23.5 15.875 22.4062 18.5312 20.2188 20.7188C18.0312 22.9062 15.375 24 12.25 24ZM12.25 21.5C14.0833 21.5 15.7292 20.9948 17.1875 19.9844C18.6458 18.974 19.7083 17.6563 20.375 16.0312C19.9583 16.1354 19.5417 16.2187 19.125 16.2812C18.7083 16.3437 18.2917 16.375 17.875 16.375C15.3125 16.375 13.1302 15.474 11.3281 13.6719C9.52604 11.8698 8.625 9.6875 8.625 7.125C8.625 6.70833 8.65625 6.29167 8.71875 5.875C8.78125 5.45833 8.86458 5.04167 8.96875 4.625C7.34375 5.29167 6.02604 6.35417 5.01563 7.8125C4.00521 9.27083 3.5 10.9167 3.5 12.75C3.5 15.1667 4.35417 17.2292 6.0625 18.9375C7.77083 20.6458 9.83333 21.5 12.25 21.5Z",
    fill: "var(--icon-fill)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/darkMode.53d29cd5cb2968881d0288f52e7ba1c9.svg";
export { ForwardRef as ReactComponent };